import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MenuApiService } from '../menu-api.service';
import {LocationSetTypesActions} from '@emm/menu/store/location-set-types/location-set-types.actions';

@Injectable({
    providedIn: 'root'
})
export class LocationSetTypesEffects {

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LocationSetTypesActions.load),
            switchMap(() =>
                this.api.getAllLocationSetTypes().pipe(
                    map(locationSetTypes => LocationSetTypesActions.loadSuccess({ locationSetTypes })),
                    catchError(error => of(LocationSetTypesActions.loadFailure({ error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private api: MenuApiService) {}

}
